import { Row } from "components/Layout";
import { FieldType } from "containers/Settings/RuleBooks/constants";
import { withNamespace } from "components/Form/FormikControls";
import React from "react";
import { DataSource as DataSourceField } from "containers/Settings/RuleBooks/DataSource";

import { GlobalBusinessDataSourceField } from "containers/Settings/RuleBooks/DataSource/GlobalBusinessDataSource";

import { SchemaFieldDataSourceField } from "containers/Settings/RuleBooks/DataSource/SchemaFieldDataSource";
import { ConstantDataSourceField } from "containers/Settings/RuleBooks/DataSource/ConstantDataSource";

export type BusinessDataSource =
  | GlobalBusinessDataSourceField
  | ConstantDataSourceField
  | SchemaFieldDataSourceField;

export interface ToFromFormValues {
  from_business: BusinessDataSource;
  to_business: BusinessDataSource;
}

export interface ToFromFormProps {
  namespace?: string;
  ruleInputPath: string;
  parentInputPath: string | null;
  showPrerequisiteRuleSource: boolean;
}

export function ToFromForm(props: ToFromFormProps) {
  const {
    namespace: ns = "",
    ruleInputPath,
    parentInputPath = null,
    showPrerequisiteRuleSource,
  } = props;
  return (
    <>
      <Row full alignCenter paddingVertical={1} gridGap={2}>
        <span>Billed from: </span>
        <DataSourceField
          dataTour="billedFrom"
          fieldType={FieldType.BUSINESS}
          namespace={withNamespace(ns, "from_business")}
          includeGlobalBusinesses
          showProperties
          showRelations
          fieldPath={ruleInputPath}
          parentInputPath={parentInputPath}
          showPrerequisiteRuleSource={showPrerequisiteRuleSource}
        />
      </Row>
      <Row full alignCenter paddingVertical={1} gridGap={2}>
        <span>Billed to: </span>
        <DataSourceField
          dataTour="billedTo"
          fieldType={FieldType.BUSINESS}
          namespace={withNamespace(ns, "to_business")}
          includeGlobalBusinesses
          showProperties
          showRelations
          fieldPath={ruleInputPath}
          parentInputPath={parentInputPath}
          showPrerequisiteRuleSource={showPrerequisiteRuleSource}
        />
      </Row>
    </>
  );
}
